/* eslint-disable */
if (
  !global._babelPolyfill &&
  (typeof window === 'undefined' || !window._babelPolyfill)
) {
  require('@babel/polyfill')
}
const hot = require('./hotloading')

const ns = typeof window === 'undefined' ? global : window
ns.React = require('react')
ns.ReactDOM = require('react-dom')
ns.ReactDOMServer = require('react-dom/server')

// global debounce for scroll-top
ns.deprecatedDebounce = require('lodash.debounce')

// Stub Polyfill for matchMedia which is used by enquire.js
// we don't actually care about properly polyfilling it, we just don't want
// an error thrown in IE 9 about it
ns.matchMedia = ns.matchMedia || require('shared/match-media-stub').default

/**
 * We only want to init analytics in clients and suppress analytics
 * side effects in journey testing (env !== 'prod' && noop === true).
 */
if (typeof window !== 'undefined') {
  if (window.__BL_ANALYTICS__.store_name === 'Babylist Health') {
    ns.blAnalytics = require('./lib/babylistHealthAnalytics')
  } else {
    ns.blAnalytics = require('./lib/analytics')
  }

  ns.blAnalytics.initAnalytics({
    // Setting strict to false while we're ramping up our Avo setup.
    // Otherwise the errors would be loud and block rendering/tests, but
    // we just want to use the avo debugging tools.
    strict: false,
    env: window.__BL_ANALYTICS__.env,
    inspectorEnv: window.__BL_ANALYTICS__.inspector_env,
    branchId: window.__BL_ANALYTICS__.branch_id,
    appVersion: window.__BL_ANALYTICS__.app_version,
    noop: window.__BL_ANALYTICS__.env === window.__BL_ANALYTICS__.TEST,
  })
}

// global fetch
ns.fetch = ns.fetch || require('./lib/fetch').default

// global pubsub for times that it's needed
ns.PubSub = require('./lib/pubsub').shared()

// intended to be the only way to update the global currentUser
ns.PubSub.subscribe('currentUser.update', (updateObj) => {
  ns.currentUser = { ...ns.currentUser, ...updateObj }
})

ns.blUrls = require('./lib/urls')
ns.blCookies = require('./lib/cookies')
ns.BLConstants = hot(module)(require('./shared/constants.js'))

// only include components that are navigational or need to be loaded from bl_registry/layouts/application
// all other React components should be included in the appropriate bundle if referenced from Rails view
ns.AnitasHouseBanner = hot(module)(
  require('./anitas_house_banner/banner').default
)
ns.AppModal = hot(module)(require('./shared/app-modal').default)
ns.AuthModal = hot(module)(require('./shared/auth-modal').default)
ns.BackBanner = hot(module)(require('./components/banners/back-banner').default)
ns.FlashMessage = hot(module)(require('./shared/flash-message'))
ns.Footer = hot(module)(require('./shared/footer').default)
ns.GlobalNav = hot(module)(require('./components/global-nav').default)
ns.Header = hot(module)(require('./components/header').default)
ns.MobileTabBar = hot(module)(require('./shared/mobile-tab-bar').default)
ns.Redirect = hot(module)(require('./pages/redirect').default)

// dynamically generated from Contentful content
ns.BLImage = hot(module)(require('./components/image').default)
ns.HeartRating = hot(module)(require('./components/heart-rating').default)
ns.PinnableImage = hot(module)(require('./shared/pinnable-image').default)

ns.trackSession = () => {
  if (!ns.navigator?.cookieEnabled) return

  const lastPageLoad = ns.blCookies.getLastPageLoadCookie()

  if (!lastPageLoad) {
    const currentUrlWithoutQueryString = ns.location?.href.split('?')[0]
    ns.blCookies.setSessionStartedUrl(currentUrlWithoutQueryString)
    ns.blAnalytics.track.sessionStarted({
      eventUrl: currentUrlWithoutQueryString,
      userId: ns.currentUser?.id,
    })
  }
  ns.blCookies.setLastPageLoadCookie()
}
